import React from 'react';
import { PageHero } from '../components/PageHero';
import { PostCard } from '../components/blog/PostCard';
import { images } from '../data/images';
import { posts } from '../data/postsClean';
export function Blog() {
  const [featured, ...rest] = posts;
  return <>
      <PageHero title="Blog" subtitle="Meet Rick Trip & explore Las Vegas" image={images.vegasNeon} data-id="element-305" data-mp="qxaj2eeg1ruj" />
      <section className="px-6 pb-[clamp(60px,6vw,160px)]" data-id="element-306" data-mp="37g9c5pf8jei">
        {featured && <PostCard post={featured} featured data-id="element-307" data-mp="35n1wo6zhv5g" />}
        <div className="mt-[clamp(40px,4vw,100px)] grid gap-x-[clamp(18px,2vw,50px)] gap-y-16 border-t border-ink-line pt-16 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4" data-id="element-308" data-mp="3uesgdrwlbggp">
          {rest.map(post => <PostCard key={post.slug} post={post} data-id="element-309" data-mp="85rjkhjmovx9" />)}
        </div>
      </section>
    </>;
}